import get from 'lodash/get'
import {actionChannel, delay, flush, fork, put, select, take} from 'redux-saga/effects'

import {BadResponse} from '../exceptions'

export const leadingThrottle = (ms, pattern, task, ...args) =>
  fork(function* leadingThrottleWorker() {
    const channel = yield actionChannel(pattern)

    // take an action, start a worker, wait XXXms before we accept another action
    for (;;) {
      // linter friendly `while (true)`
      const action = yield take(channel)
      yield fork(task, ...args, action) // we don't cancel any existing tasks, which makes this like `takeEvery`
      yield delay(ms) // time until we will begin respecting actions again
      yield flush(channel) // clear all buffered actions (this is the difference between the built-in `throttle` function)
    }
  })

export const getJson = (response) => get(response, 'json')
export const throwBadResponseError = ({status}) => {
  throw new BadResponse(status)
}

// make an API call if some condition is not satisfied
export const callIfNotExist = (satisfySelector, action, failureType, successType, errorMessage) =>
  function* callIfNotExistWorker() {
    // if we haven't been able to successfully retrieve fit profile, try again
    if (!(yield select(satisfySelector))) {
      yield put(action())

      const result = yield take([failureType, successType])

      if (result.type !== successType) {
        throw new Error(errorMessage)
      }
    }
  }
